
import { supabase } from "@/integrations/supabase/client";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

let isInitialized = false;

export async function initializeAnalytics() {
  if (isInitialized) return;

  try {
    const { data, error } = await supabase
      .from('config')
      .select('value')
      .eq('key', 'GOOGLE_ANALYTICS_ID')
      .maybeSingle();

    if (error) throw error;
    if (!data) {
      console.warn('Google Analytics ID not found in config');
      return;
    }

    const measurementId = data.value;

    // Load Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    isInitialized = true;
    console.log('Google Analytics initialized');
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (!window.gtag) {
    console.warn('Google Analytics not initialized');
    return;
  }
  window.gtag('event', eventName, params);
}

export function trackImageCombination(imageCount: number, format: string, success: boolean) {
  trackEvent('combine_images', {
    image_count: imageCount,
    format,
    success,
  });
}

export function trackDownload(format: string) {
  trackEvent('download_image', {
    format,
  });
}
